export default {
  IDENTIFIER_TYPE_LIST: 'list',
  IDENTIFIER_TYPE_TOTAL_LIST: 'total_list',
  IDENTIFIER_TYPE_DETAILS: 'details',
  IDENTIFIER_TYPE_ITEM: 'item',
};
